import React, {useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';
import cx from 'classnames';
import Box from '@material-ui/core/Box';
import Message from '../common/Message';
import getRouteConfigs from '../../routes/getRouteConfigs';
import {NavLink} from 'react-router-dom';
import {generateRoutePath} from 'epic-common/src/route';
import {Icon, svgs} from 'epic-diesel-common';
import {isActiveAffiliate} from '../../../shared/utils/ValidationUtils';
import {Affiliate} from '../../../shared/types';
import {AccountInfo} from '../../reducers/user.reducer';
import {TaxState} from '../../reducers/tax';

//@ts-ignore
import styles from './MenuLinks.pcss';

export interface MenuLinksProps {
    affiliate: Affiliate;
    configState: any;
    isLoggedIn?: AccountInfo['isLoggedIn'];
    taxCountrySanctioned?: TaxState['taxCountrySanctioned'];
}

const MenuLinks: React.FC<MenuLinksProps> = ({
    affiliate,
    configState,
    isLoggedIn = false,
    taxCountrySanctioned = false
}) => {
    const [toggled, toggleMenu] = useState(false);
    const {tab} = useParams();
    const initialRoutes = getRouteConfigs(tab);
    const {routes, routeMap} = useMemo(() => initialRoutes, []);
    const {enableEarnings, enableNews, enableFnGames} = configState || {};
    const classes = cx({[styles.menuActive]: toggled});

    return (
        <Box sx={{flex: 1}} className={classes}>
            <div className={styles.menuControl}>
                <button onClick={() => toggleMenu(!toggled)}>
                    <Icon icon={svgs.CHEVRON_DOWN} fontSize="small" />
                </button>
            </div>
            <div className={styles.menuLinks}>
                {!isLoggedIn || taxCountrySanctioned ? (
                    <NavLink
                        activeClassName={styles.active}
                        to={generateRoutePath(routeMap.overview.path)}>
                        <Message code={routeMap.overview.label} />
                    </NavLink>
                ) : !isActiveAffiliate(affiliate) ? (
                    <>
                        <NavLink
                            activeClassName={styles.active}
                            to={generateRoutePath(routeMap.overview.path)}>
                            <Message code={routeMap.overview.label} />
                        </NavLink>

                        {affiliate && affiliate.canEditSettings && (
                            <NavLink
                                activeClassName={styles.active}
                                to={generateRoutePath(routeMap.settings.path)}>
                                <Message code={routeMap.settings.label} />
                            </NavLink>
                        )}
                    </>
                ) : (
                    routes.map(route => {
                        if (
                            (route.path === 'news' && !enableNews) ||
                            (route.path === 'dashboard' && !enableEarnings) ||
                            (route.path === 'fortnite-games' && !enableFnGames)
                        ) {
                            return null;
                        }

                        return (
                            <NavLink
                                key={route.path}
                                activeClassName={styles.active}
                                to={generateRoutePath(route.path)}>
                                <Message code={route.label} />
                                {route.icon && <Icon icon={route.icon} />}
                            </NavLink>
                        );
                    })
                )}
            </div>
        </Box>
    );
};

export default MenuLinks;
